import React from 'react'
import { DateFilterContextType } from './dateFilter.types'

export const DateFilterContext = React.createContext<DateFilterContextType>(
  null as unknown as DateFilterContextType
)

export const useDateFilterContext = () => {
  return React.useContext(DateFilterContext)
}
